import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const Select = ({ onChange, values, value, name }) => (
  <div className={styles.container}>
    <select onChange={onChange} value={value} name={name}>
      {values.map((item) => (
        <option value={item} key={item}>
          {item}
        </option>
      ))}
    </select>
  </div>
);

Select.propTypes = {
  onChange: PropTypes.func,
  values: PropTypes.arrayOf(PropTypes.number),
  value: PropTypes.number,
  name: PropTypes.string,
};

Select.defaultProps = {
  onChange: () => {},
  values: null,
  value: 0,
  name: '',
};

export default Select;
